<app-main-dialog (dismiss)="dismiss()">
  <div desktopTitle>
    @if (!item()?.guid) {
      {{ 'sites.newTitle' | translate }}
    } @else {
      {{ item().project }}
    }
  </div>
  <form class="ion-padding-bottom"
    [formGroup]="formGroup"
    (ngSubmit)="save()">
    @if (companies$ | async; as companies) {
      <div class="flex flex-justify-between flex-align-center">
        <p>{{ 'companies.info' | translate }}</p>
        <div>
          <ion-button color="light"
            shape="round"
            (click)="onSelectCompany(companies)">
            @if (formGroup.get('company').value) {
              {{ formGroup.get('company').value.name }}
            } @else {
              {{ 'clients.newTitle' | translate }}
            }
          </ion-button>
        </div>
      </div>
    }
    @if (item()?.image) {
      <div class="img-container">
        <img class="image"
          [src]="item().image" />
        <ion-button color="danger"
          (click)="removeImage()">
          <ion-icon slot="icon-only"
            name="remove-circle-outline"></ion-icon>
        </ion-button>
      </div>
    } @else {
      <div>
        <app-camera-button class="only-camera"
          [name]="item().guid"
          color="light"
          fill="clear"
          [multiline]="true"
          (imageUrl)="onImageUrl($event)"></app-camera-button>
      </div>
    }
    <h4>{{ 'item.name' | translate }} *</h4>
    <ion-item lines="none">
      <ion-input autocapitalize="on"
        formControlName="project"></ion-input>
    </ion-item>
    <div class="divider"></div>
    <div class="flex address-title">
      <h4>{{ 'sites.new.streetAddress' | translate }} *</h4>
      <div class="flex-align-center">
        <ion-button color="light"
          class="action-button"
          shape="round"
          size="small"
          (click)="updateLocation()">
          <app-loading-button [loading]="loadingLocation()">
            {{ 'sites.new.updateLocation' | translate }}
          </app-loading-button>
        </ion-button>
        @if (item().location != null) {
          <ion-button color="light"
            shape="round"
            size="small"
            (click)="openMap(item().location)">{{ 'sites.new.showLocation' | translate }}</ion-button>
        }
      </div>
    </div>
    <ion-item lines="none">
      <ion-input autocapitalize="on"
        formControlName="streetAddress"></ion-input>
    </ion-item>
    <h4>{{ 'sites.new.postalCode' | translate }} *</h4>
    <ion-item lines="none">
      <ion-input autocapitalize="on"
        formControlName="postalCode"
        type="tel"></ion-input>
    </ion-item>
    <h4>{{ 'sites.new.city' | translate }} *</h4>
    <ion-item lines="none">
      <ion-input autocapitalize="on"
        formControlName="city"></ion-input>
    </ion-item>
    <div class="divider"></div>
    @if (role() === 'admin') {
      <h4>{{ 'site.manager.admin' | translate }}</h4>
      <app-select-user-button [items]="users$ | async"
        [selectedUser]="manager()"
        (selected)="onManager($event)"></app-select-user-button>
      <h4>{{ 'site.manager.technical' | translate }}</h4>
      <app-select-user-button [items]="users$ | async"
        [selectedUser]="technical()"
        (selected)="onManager($event, true)"></app-select-user-button>
    } @else if (role() === 'commercial-admin') {
      <h4>{{ 'site.commercialAdmin.admin' | translate }}</h4>
      <app-select-user-button [items]="users$ | async"
        [multiple]="true"
        [selectedUser]="managers()"
        (selected)="onManagers($event)"></app-select-user-button>
      <h4>{{ 'site.commercialAdmin.technical' | translate }}</h4>
      <app-select-user-button [items]="users$ | async"
        [multiple]="true"
        [selectedUser]="technicals()"
        (selected)="onTechnicals($event)"></app-select-user-button>
    }
    <div class="divider"></div>
    <div class="ion-margin-top">
      <ion-button color="tertiary"
        shape="round"
        type="submit"
        [disabled]="!formGroup.valid">
        <app-loading-button [loading]="saving()">
          {{ 'general.save' | translate }}
        </app-loading-button>
      </ion-button>
    </div>
  </form>
</app-main-dialog>